<!-- Zweck: Stellt die HTML-Struktur für app notification list component im Frontend bereit. -->
<section-title [hasBack]="true" label="Alle Benachrichtigungen" icon="benachrichtigungen"></section-title>

@if (notifications|async) {
  <div style="text-align: center">
    @if ((notifications|async)?.length == 0) {
      <div align="center"  class="notbox mat-elevation-z1">
        <h3>Keine Benachrichtigungen vorhanden!</h3>
      </div>
    }
    @for (notification of notifications|async; track notification; let last = $last) {
      <div class="notbox mat-elevation-z1" [class.seperatorbox]="!last">
        <app-notification-entry [notification]="notification" [parent]="this"
        [show_dismissable]="false" [show_seen]="true"></app-notification-entry>
      </div>
    }
  </div>
}
